export const DEFAULT_JUSBRASIL_COOKIE_PATH = '/'
export const DEFAULT_JUSBRASIL_COOKIE_DOMAIN = '.jusbrasil.com.br'
